(() => {
  const locale = document.documentElement.lang.split('-')[0];
  const entriesByLocale = {
  "en": [
    {
      "id": "shift-ii-mistral",
      "mediaId": "46255213314241",
      "url": "https://cdn.shopify.com/videos/c/o/v/67f8f75fe3ca4583ad2700f373328cdf.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/spek-shift-ii-mistral-light-preview-updated-20260930-en.jpg?v=1790796949"
    },
    {
      "id": "shift-ii-flamme",
      "mediaId": "46255213281473",
      "url": "https://cdn.shopify.com/videos/c/o/v/8dc048d015254939b4503c5a5bf1019c.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/spek-shift-ii-flamme-light-preview-updated-20260930-en.jpg?v=1790797078"
    },
    {
      "id": "shift-ii-nordique",
      "mediaId": "46255213347009",
      "url": "https://cdn.shopify.com/videos/c/o/v/1cf8a8b3a45540ac8729ba4b2f864221.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/spek-shift-ii-nordique-light-preview-updated-20260930-en.jpg?v=1790797126"
    },
    {
      "id": "shift-ii-alpine",
      "mediaId": "46255213248705",
      "url": "https://cdn.shopify.com/videos/c/o/v/71eed0cddccf42a4a73da04cc1d0bbdd.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/spek-shift-ii-alpine-light-preview-updated-20260930-en.jpg?v=1790797133"
    },
    {
      "id": "shift-ii-white-mistral",
      "mediaId": "46255213412545",
      "url": "https://cdn.shopify.com/videos/c/o/v/330139cc0fb04de381d0d18894c91c07.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/spek-shift-ii-white-mistral-light-preview-updated-20260930-en.jpg?v=1790797233"
    },
    {
      "id": "shift-ii-tundra",
      "mediaId": "46255213379777",
      "url": "https://cdn.shopify.com/videos/c/o/v/2edf5e2e117140a090413cbff8dd4801.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/spek-shift-ii-tundra-light-preview-updated-20260930-en.jpg?v=1790797185"
    },
    {
      "id": "nova-mistral",
      "mediaId": "46252488360129",
      "url": "https://cdn.shopify.com/videos/c/o/v/eaea17b6b20b4ac293e01cbc65f259a8.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/preview_images/spek-nova-mistral-light-preview-20260930-en.jpg?v=1790783149"
    },
    {
      "id": "nova-nordique",
      "mediaId": "46252488392897",
      "url": "https://cdn.shopify.com/videos/c/o/v/7f78de76fe6a44c29df284995845fb80.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/preview_images/spek-nova-nordique-light-preview-20260930-en.jpg?v=1790783149"
    },
    {
      "id": "nova-white-mistral",
      "mediaId": "46254856962241",
      "url": "https://cdn.shopify.com/videos/c/o/v/e30762f322e940458ede12f44d9a3a3b.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/preview_images/spek-nova-white-mistral-light-preview-20260930-en.jpg?v=1790787497"
    },
    {
      "id": "nova-white-nordique",
      "mediaId": "46254857027777",
      "url": "https://cdn.shopify.com/videos/c/o/v/5689c53f9aca42fa9d9c57648eab6227.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/preview_images/spek-nova-white-nordique-light-preview-20260930-en.jpg?v=1790787497"
    },
    {
      "id": "scope-aurore",
      "mediaId": "46252488425665",
      "url": "https://cdn.shopify.com/videos/c/o/v/e11768f362834e2b9befdbd04f41eb62.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/preview_images/spek-scope-aurore-light-preview-20260930-en.jpg?v=1790783149"
    },
    {
      "id": "scope-flamme",
      "mediaId": "46252488491201",
      "url": "https://cdn.shopify.com/videos/c/o/v/d72c942bcf8647fd9322366d321e4a37.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/preview_images/spek-scope-flamme-light-preview-20260930-en.jpg?v=1790783149"
    },
    {
      "id": "scope-dusk",
      "mediaId": "46252488458433",
      "url": "https://cdn.shopify.com/videos/c/o/v/4430950b1cea4df38d71d56f610a1422.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/preview_images/spek-scope-dusk-light-preview-20260930-en.jpg?v=1790783149"
    },
    {
      "id": "scope-white-aurore",
      "mediaId": "46254857093313",
      "url": "https://cdn.shopify.com/videos/c/o/v/5d248502c8bb4858ac9217ad4b140929.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/preview_images/spek-scope-white-aurore-light-preview-20260930-en.jpg?v=1790787497"
    },
    {
      "id": "scope-white-dusk",
      "mediaId": "46254857158849",
      "url": "https://cdn.shopify.com/videos/c/o/v/74e60efd4f5c468091a05eda589966f8.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/preview_images/spek-scope-white-dusk-light-preview-20260930-en.jpg?v=1790787497"
    },
    {
      "id": "scope-camo-flamme",
      "mediaId": "46254857224385",
      "url": "https://cdn.shopify.com/videos/c/o/v/a0a90798a643491b9fbf49e2a2ca8b8e.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/preview_images/spek-scope-camo-flamme-light-preview-20260930-en_2dc871a6-3baf-4eaa-8c75-0aa5536af56d.jpg?v=1790787497"
    },
    {
      "id": "scope-camo-dusk",
      "mediaId": "46254857289921",
      "url": "https://cdn.shopify.com/videos/c/o/v/dd0c73338fe04fd2bcc9babd22489b32.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/preview_images/spek-scope-camo-dusk-light-preview-20260930-en.jpg?v=1790787498"
    }
  ],
  "fr": [
    {
      "id": "shift-ii-mistral",
      "mediaId": "46255213314241",
      "url": "https://cdn.shopify.com/videos/c/o/v/067d1f5f867644019c2d9633d520dbac.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/spek-shift-ii-mistral-light-preview-updated-20260930-fr.jpg?v=1790796706"
    },
    {
      "id": "shift-ii-flamme",
      "mediaId": "46255213281473",
      "url": "https://cdn.shopify.com/videos/c/o/v/24d72abf0c194fe6b2e0a028a8246bc8.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/spek-shift-ii-flamme-light-preview-updated-20260930-fr.jpg?v=1790796714"
    },
    {
      "id": "shift-ii-nordique",
      "mediaId": "46255213347009",
      "url": "https://cdn.shopify.com/videos/c/o/v/e393e1224a544b6eb404acc496e5dcb6.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/spek-shift-ii-nordique-light-preview-updated-20260930-fr.jpg?v=1790796800"
    },
    {
      "id": "shift-ii-alpine",
      "mediaId": "46255213248705",
      "url": "https://cdn.shopify.com/videos/c/o/v/08d55b5d7ae74d1580e5c3688b1a220d.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/spek-shift-ii-alpine-light-preview-updated-20260930-fr.jpg?v=1790796851"
    },
    {
      "id": "shift-ii-tundra",
      "mediaId": "46255213379777",
      "url": "https://cdn.shopify.com/videos/c/o/v/1f62c7e637ff4bc5b4acad72c3d80e16.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/spek-shift-ii-tundra-light-preview-updated-20260930-fr.jpg?v=1790796857"
    },
    {
      "id": "shift-ii-white-mistral",
      "mediaId": "46255213412545",
      "url": "https://cdn.shopify.com/videos/c/o/v/6a7ff157425f4ffba64a95309f23a0a2.mp4",
      "poster": "https://cdn.shopify.com/s/files/1/0624/8661/0113/files/spek-shift-ii-white-mistral-light-preview-updated-20260930-fr.jpg?v=1790796942"
    }
  ]
};
  const entries = entriesByLocale[locale];
  if (!entries) return;
  const byMedia = new Map(entries.map(entry => [entry.mediaId, entry]));
  let queued = false;

  function entryFor(element) {
    const owner = element.closest('[data-image-id], [data-media-id]');
    if (!owner) return null;
    const id = owner.getAttribute('data-image-id') || owner.getAttribute('data-media-id');
    return byMedia.get(id) || byMedia.get(id.split('-').pop()) || null;
  }

  function setAttribute(element, name, value) {
    if (element.getAttribute(name) === value) return false;
    element.setAttribute(name, value);
    return true;
  }

  function updateImage(image, entry) {
    setAttribute(image, 'src', entry.poster);
    if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
    if (image.hasAttribute('data-srcset')) image.removeAttribute('data-srcset');
    if (image.hasAttribute('data-src')) setAttribute(image, 'data-src', entry.poster);
    const picture = image.closest('picture');
    if (picture) picture.querySelectorAll('source[srcset]').forEach(source => {
      setAttribute(source, 'srcset', entry.poster);
    });
  }

  function apply() {
    queued = false;
    document.querySelectorAll('.product__slide video, [data-media-id] img, .product__slide img').forEach(element => {
      const entry = entryFor(element);
      if (!entry) return;
      if (element.tagName === 'IMG') {
        updateImage(element, entry);
        return;
      }
      const playing = !element.paused;
      setAttribute(element, 'poster', entry.poster);
      element.querySelectorAll('source').forEach(source => {
        setAttribute(source, 'src', entry.url);
        setAttribute(source, 'type', 'video/mp4');
      });
      if (setAttribute(element, 'src', entry.url)) {
        element.load();
        if (playing) {
          const promise = element.play();
          if (promise) promise.catch(() => {});
        }
      }
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    queueMicrotask(apply);
  }

  const observer = new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' ||
      entryFor(record.target))) schedule();
  });
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['src', 'srcset', 'poster', 'data-src', 'data-srcset', 'data-media-id', 'data-image-id']
  });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('DOMContentLoaded', schedule, {once: true});
  apply();
})();
